import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  width: 100%;
`

export const Title = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  background-color: ${props => props.theme.palette.brand.gray3};
  padding: 4px;
  max-width: 159px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 27px;
  line-height: 32px;
  margin: 8px 0 0;

  ${props => props.theme.breakpoints.up('sm')} {
    margin: 57px 0 0;
  }
`

export const Description = styled('p')`
  display: inline-block;
  color: ${props => props.theme.palette.brand.black1};
  background-color: ${props => props.theme.palette.brand.gray3};
  padding: 4px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 19px;
`

export const Content = styled(ContainerBase)``

export const Row = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Column = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`
